import type { CustReqNoticeItem, CustReqNoticePhoto, CustReqNoticeFields } from '../../types/custReqNotice.types';

// 반장 작업요청 안내 화면의 고객 요청(S16) 순수 로직 — 카드 노출 판정·사진 정렬·문구.
// 근거: 기획 P_기획발췌 4.3(작업요청 상세보기), 확정결정 Q-13(공정 불확정이면 영역 숨김·안내 없음), K1 2.9.

export const CUST_REQ_NOTICE_MESSAGE = {
  title: '고객 요청',
  guide: '작업보고 쓸 때 반영한 요청을 체크해 주세요',
  requestPhoto: '고객 요청 사진',
} as const;

/** 건수 문구 — '고객 요청 n건' */
export function noticeTitle(count: number): string {
  return `${CUST_REQ_NOTICE_MESSAGE.title} ${count}건`;
}

/** 사진 순번 오름차순(원본 배열 불변) */
export function sortNoticePhotos(photos: readonly CustReqNoticePhoto[] | null | undefined): CustReqNoticePhoto[] {
  return [...(photos ?? [])].sort((a, b) => a.photoSeq - b.photoSeq);
}

/**
 * 안내 응답에서 카드로 보일 요청 목록 — 필드가 없거나 비면 빈 배열(카드 숨김, 안내 없음).
 * 서버가 이미 접수 순으로 내려주므로 요청 순서는 그대로 두고 사진만 순번 정렬한다.
 */
export function pickNoticeItems(data: CustReqNoticeFields | null | undefined): CustReqNoticeItem[] {
  const list = data?.customerRequests;
  if (!Array.isArray(list)) return [];
  return list.map((r) => ({ ...r, photos: sortNoticePhotos(r.photos) }));
}
